import { render } from "./EmptyMessage.vue?vue&type=template&id=7cf1804e&scoped=true&ts=true"
import script from "./EmptyMessage.vue?vue&type=script&lang=ts"
export * from "./EmptyMessage.vue?vue&type=script&lang=ts"

import "./EmptyMessage.vue?vue&type=style&index=0&id=7cf1804e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf1804e"]])

export default __exports__